var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { staticClass: "relative", attrs: { xs: "12" } },
                [
                  _c("app-custom-language-select", {
                    attrs: {
                      up: "",
                      disabled: !_vm.isValid && _vm.otherLanguagesValid,
                    },
                    model: {
                      value: _vm.selectedLang,
                      callback: function ($$v) {
                        _vm.selectedLang = $$v
                      },
                      expression: "selectedLang",
                    },
                  }),
                  !_vm.otherLanguagesValid
                    ? _c("w-fa", {
                        staticClass: "error-in-other-lang-notification",
                        attrs: { icon: "exclamation-circle" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-input-with-textarea-modal", {
                    ref: "textarea",
                    attrs: {
                      value: _vm.value.Translations[_vm.selectedLang] || "",
                      editor: true,
                      label: _vm.$ct("template"),
                      fancy: "",
                      "modal-title": _vm.$ct("template"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.value.Translations[_vm.selectedLang] = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _c("w-col", { attrs: { xs: "12" } }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("app-prop-select-autocomplete", {
                      staticClass: "mr",
                      style: { flexGrow: 1 },
                      attrs: {
                        fancy: "",
                        label: _vm.$ct("to-add-prop"),
                        items: _vm.items,
                      },
                      model: {
                        value: _vm.selectedProp,
                        callback: function ($$v) {
                          _vm.selectedProp = $$v
                        },
                        expression: "selectedProp",
                      },
                    }),
                    _c(
                      "w-button",
                      {
                        style: { flexGrow: 0, flexShrink: 0 },
                        attrs: {
                          icon: "plus",
                          disabled: !_vm.addPropButtonEnabled,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addProp()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$ct("add-prop")))]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }